import React, { Component } from "react";
import "./NyanCat.css";
import RainbowChunk from "../assets/nyanrainbowchunk.png";

const Cat = () => <div className="nyan" />;

const Rainbow = () => {
  const chunkCount = 30;
  const chunks = [];
  for (let i = 0; i < chunkCount; i++) {
    const upDown = i % 2 === 0 ? "even" : "odd";
    chunks.push(
      <img
        key={i}
        className={`rainbow-chunk-${upDown}`}
        src={RainbowChunk}
        alt="It's a nyan cat"
      />
    );
  }

  return chunks;
};

export default class NyanCat extends Component {
  componentDidMount() {
    const nyan = document.querySelector(".nyan");
    const wrapper = document.querySelector(".nyan-wrapper");
    moveCat(nyan, wrapper);
    start(wrapper);
  }

  render() {
    return (
      <div className="nyan-wrapper">
        <Rainbow />
        <Cat />
      </div>
    );
  }
}

function start(wrapper) {
  window.setTimeout(() => {
    wrapper.classList.add("nyan-wrapper-transitioned");
  }, 500);
}

function moveCat(nyan, wrapper) {
  let frame = 0;
  window.setInterval(() => {
    nyan.style["background-position"] = 34 * frame + "px";
    frame++;
  }, 60);

  let mod = -1;
  window.setInterval(() => {
    wrapper.style.setProperty("--rainbow-chunk-offset", 3 * mod);
    mod = mod * -1;
  }, 200);
}



// WEBPACK FOOTER //
// ./src/components/NyanCat.js